import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'common.description',
        maxlength: 64,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    returnCauseOption: {
      type: Select,
      defaultValue: '',
      props: {
        caption: 'return.returnCause',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('returnCause'),
        required: true
      },
      rules: [{ validator: validatorRequireNumber }]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
